import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'

// Mantine's stylesheets, imported BEFORE ./index.css so this app's own rules win where they
// overlap. Every Mantine component is unstyled without these — it renders, it is just visually
// broken, which is a hard failure to diagnose from the console because nothing errors.
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'

import store from './store/store'
import { selectLanguage } from './i18n/selectLanguage'
import theme from './theme'
import App from './App.jsx'
import './index.css'

const { lang, resources } = selectLanguage()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <MantineProvider theme={theme}>
      <Provider store={store}>
        <IntlProvider locale={lang} messages={resources} defaultLocale="en">
          {/* Derived from Vite's `base`, never hardcoded: one source of truth for the prefix, so
              the bundle's asset URLs and the router's routes cannot disagree.

              The trailing slash MUST be stripped. Vite's BASE_URL is `/app/`, and React Router
              requires a basename without one: given basename `/app/` and a location of `/app`, the
              location does not start with the basename, so the router decides it is outside its base
              and renders NOTHING — a blank page, with no error in the console and every asset
              loading with a 200. Observed exactly that on the first two-frontend deploy. */}
          <BrowserRouter basename={import.meta.env.BASE_URL.replace(/\/$/, '')}>
            <Notifications position="top-right" />
            <App />
          </BrowserRouter>
        </IntlProvider>
      </Provider>
    </MantineProvider>
  </React.StrictMode>,
)
